// angular
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
// app
import { AppMaterialModule } from '../../app.material';
import { ForgotComponent } from './forgot/forgot.component';
import { LayoutLoginComponent } from './layout/layout.component';
import { LoginRoutingModule } from './login.routing';
import { LogoutComponent } from './logout/logout.component';
import { PendingActivationComponent } from './switch/pending-activation/pending-activation.component';
import { SignInComponent } from './signin/signin.component';
import { SignUpComponent } from './signup/signup.component';
import { SwitchComponent } from './switch/switch.component';
import { UserCompanyComponent } from './switch/user-company/user-company.component';
import { VerifyComponent } from './verify/verify.component';
import { AppSharedModule } from 'src/app/_shared/app.shared.module';
//Rebillia library components
import { RebNgxBannerModule } from '@rhinosaas/reb-ngx/reb-ngx-banner';
import { RebNgxCardModule } from '@rhinosaas/reb-ngx/reb-ngx-card';
import { RebNgxListableCardModule } from '@rhinosaas/reb-ngx/reb-ngx-listable-card';
import { RebNgxMatButtonModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-button';
import { RebNgxMatSelectModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-select';
import { RebNgxMatOptionModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-option';
import { RebNgxLabelModule } from '@rhinosaas/reb-ngx/reb-ngx-label';
import { RebNgxHeadingLabelModule } from '@rhinosaas/reb-ngx/reb-ngx-heading-label';
import { RebNgxDividerModule } from '@rhinosaas/reb-ngx/reb-ngx-divider';

const COMPONENTS: any[] = [
  LayoutLoginComponent,
  LogoutComponent,
  ForgotComponent,
  PendingActivationComponent, 
  SignInComponent,
  SignUpComponent,
  SwitchComponent,
  UserCompanyComponent,
  VerifyComponent,
]

const MODULES: any[] = [
  AppMaterialModule,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  LoginRoutingModule,
  AppSharedModule,
  RebNgxBannerModule,
  RebNgxCardModule,
  RebNgxDividerModule,
  RebNgxHeadingLabelModule,
  RebNgxLabelModule,
  RebNgxListableCardModule,
  RebNgxMatButtonModule,
  RebNgxMatSelectModule,
  RebNgxMatOptionModule,
]

const PROVIDERS: any[] = [

]

@NgModule({
  declarations: [COMPONENTS],
  imports: [MODULES],
  providers: [PROVIDERS],
})
export class LoginModule {}
